import React, { useState } from 'react';
import { ScrollText, Loader2, Copy, Check } from 'lucide-react';
import { toast } from 'sonner';

export const TranscriptTab = ({ run, status }) => {
  const [copied, setCopied] = useState(false);
  const transcript = run.transcriptText || '';

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(transcript);
      setCopied(true);
      toast.success('Copied to clipboard');
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error('Failed to copy');
    }
  };

  return (
    <div className="p-4 sm:p-8">
      <h2 className="text-xl sm:text-2xl font-bold text-white mb-4 sm:mb-6">Transcript</h2>

      {!transcript ? (
        <div className="bg-brand-surface rounded-xl p-8 sm:p-12 border border-brand-surface-3 flex flex-col items-center justify-center text-center">
          {status.spinning ? (
            <>
              <Loader2 className="w-10 h-10 text-orange-400 animate-spin mb-3" />
              <p className="text-slate-300">Generating transcript…</p>
              <p className="text-slate-500 text-sm mt-1">
                This page updates in real time.
              </p>
            </>
          ) : (
            <>
              <ScrollText className="w-10 h-10 text-slate-500 mb-3" />
              <p className="text-slate-300">No transcript available yet</p>
            </>
          )}
        </div>
      ) : (
        <div className="bg-brand-surface rounded-xl p-4 sm:p-6 border border-brand-surface-3">
          <div className="flex items-center justify-between mb-3">
            <h3 className="text-base sm:text-lg font-semibold text-white flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-orange-400" />
              Transcript
            </h3>
            <button
              onClick={handleCopy}
              className="text-slate-400 hover:text-white transition-colors p-1.5 rounded-lg hover:bg-brand-surface-3"
              title="Copy transcript"
            >
              {copied ? <Check className="w-4 h-4 text-green-400" /> : <Copy className="w-4 h-4" />}
            </button>
          </div>
          <div
            dir={run.language === 'heb' ? 'rtl' : 'ltr'}
            className="text-sm sm:text-base text-slate-200 whitespace-pre-wrap break-words font-sans leading-relaxed"
          >
            {transcript}
          </div>
        </div>
      )}
    </div>
  );
};
